import { useMutation, useQuery } from 'react-query';
import { RemoteDchampsRepo } from './DchampsRepo';
// import DchampsMockRepo from './DchampsMockRepo';
import DevChampsResultListVO from '@domain/vo/dchamps/DevChampsResultListVO';
import DevChampsResultTokenVO from '@domain/vo/dchamps/DevChampsResultTokenVO';
import DevChampsApplyStatusVO from '@domain/vo/dchamps/DevChampsApplyStatusVO';
import DevChampsInfoListVO from '@domain/vo/dchamps/DevChampsInfoListVO';
import { DchampsEventType } from '@domain/constant/dchamps/eventType';

const keys = ['dchamps'];

const remoteDchampsRepo = new RemoteDchampsRepo();
// const remoteDchampsRepo = new DchampsMockRepo();

const fetchDchampsInfo = async () => {
  const { data } = await remoteDchampsRepo.fetchDchampsInfo();
  return new DevChampsInfoListVO(data);
};

export function useDchampsInfo() {
  return useQuery([...keys, 'info'], fetchDchampsInfo, {
    staleTime: Infinity,
    cacheTime: Infinity,
  });
}

const fetchDchampsGrade = async (eventType: DchampsEventType) => {
  const { data } = await remoteDchampsRepo.fetchDchampsGrade(eventType);
  return data;
};

export function useDchampsGrade(enabled: boolean, eventType: DchampsEventType) {
  return useQuery([...keys, eventType, 'grade'], () => fetchDchampsGrade(eventType), {
    enabled,
    refetchOnWindowFocus: true,
  });
}

const fetchDchampsFinalCheck = async (eventType: DchampsEventType) => {
  const { data } = await remoteDchampsRepo.fetchDchampsFinalCheck(eventType);
  return data;
};

export function useDhampsFinalsCheck(enabled: boolean, eventType: DchampsEventType) {
  return useQuery([...keys, eventType, 'qualifier'], () => fetchDchampsFinalCheck(eventType), {
    enabled,
  });
}

const fetchDchampsRanks = async (eventType: DchampsEventType) => {
  const { data } = await remoteDchampsRepo.fetchDchampsRanks(eventType);
  return data;
};

export function useDchampsRanks(eventType: DchampsEventType) {
  return useQuery([...keys, eventType, 'finals', 'user', 'list'], () => fetchDchampsRanks(eventType));
}

const fetchDchampsResults = async () => {
  const { data } = await remoteDchampsRepo.fetchDchampsResults();
  return new DevChampsResultListVO(data);
};

export function useDchampsResults(enabled: boolean) {
  return useQuery([...keys, 'results'], fetchDchampsResults, { enabled });
}

const fetchDchampsResultsToken = async (sn: number) => {
  const { data } = await remoteDchampsRepo.fetchDchampsResultsToken(sn);
  return new DevChampsResultTokenVO(data);
};

export function useDchampsResultsToken(sn: number) {
  return useQuery([...keys, 'results', 'token', sn], () => fetchDchampsResultsToken(sn));
}

const createDchampsFinalsApply = async (eventType: DchampsEventType) => {
  const { data } = await remoteDchampsRepo.createDchampsFinalsApply(eventType);
  return data;
};

export function useDchampsFinalsApply() {
  return useMutation((eventType: DchampsEventType) => createDchampsFinalsApply(eventType));
}

const fetchDchampsApplyStatus = async (eventType: DchampsEventType) => {
  const { data } = await remoteDchampsRepo.fetchDchampsApplyStatus(eventType);
  return new DevChampsApplyStatusVO(data);
};

export function useDchampsApplyStatus(enabled: boolean, eventType: DchampsEventType) {
  return useQuery([...keys, eventType, 'apply', 'status'], () => fetchDchampsApplyStatus(eventType), {
    enabled,
    refetchOnWindowFocus: true,
  });
}
